import React, { useState, useEffect } from "react";
import { Form, Spinner } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import closeeye from "../../assets/images/closeEye.svg";
import infoIcon from "../../assets/images/infobtnblue.svg";
import loginleft from "../../assets/images/loginleftnew1.png";
import logo from "../../assets/images/loginlogo.svg";
import openeye from "../../assets/images/viewaction.svg";
import { apiResponse } from "../../services/APIResponse";
import { API_URL } from "../../services/APIRoute";
import { apiCall } from "../../services/AxiosService";
import { commonservices } from "../../services/CommonServices";
import { useDispatch } from "react-redux";
import {
  userInfo,
  userRoleRight,
  userToken,
} from "../../services/ReduxTookit/UserInfoSlice";
import verifiedIcon from "../../assets/images/verified.svg";
import { ChangeLoginPassword } from "../../services/ReduxTookit/Slice/LoginRedux";
import SubmitLoading from "../common-component/Loaders/SubmitLoading";
import MainpageLoader from "../common-component/Loaders/MainpageLoader";

function ChangePassword() {
  const dispatch = useDispatch();
  let param = useParams();
  const navigate = useNavigate();
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [C_passwordVisible, setC_PasswordVisible] = useState(false);
  const [Loading, setLoading] = useState(false);
  const [input, setInput] = useState({
    userid: "",
    password: "",
    confirm_password: "",
    errors: {
      UserName: "",
      password: "",
      confirm_password: "",
      ValidationRules: [
        {
          FieldName: "password",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "confirm_password",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
      ],
    },
  });
  // const fnInputChange = (value, tag) => {
  //   if (value) {
  //     setInput({
  //       ...input,
  //       [tag]: value,
  //       errors: {
  //         ...input.errors,
  //         [tag]: "",
  //       },
  //     });
  //   } else {
  //     setInput({
  //       ...input,
  //       [tag]: "",
  //     });
  //   }
  // };

  const fnInputChange = (value, tag) => {
    if (value) {
      const updatedInput = {
        ...input,
        [tag]: value,
        errors: {
          ...input.errors,
          [tag]: "",
        },
      };

      if (tag === "password" || tag === "confirm_password") {
        if (
          updatedInput.password &&
          updatedInput.confirm_password &&
          updatedInput.password === updatedInput.confirm_password
        ) {
          updatedInput.errors.confirm_password = "";
        }
      }

      setInput(updatedInput);
    } else {
      setInput({
        ...input,
        [tag]: "",
      });
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (input.confirm_password !== "" && input.password !== "") {
      if (input.confirm_password !== input.password) {
        setInput({
          ...input,
          errors: {
            ...input.errors,
            confirm_password: "Passwords do not match",
            password: "",
            // confirm_password: input?.confirm_password
            //   ? "Passwords do not match"
            //   : "This Field is a required field",
            // password: input?.password ? "" : input.password,
          },
        });
        return;
      }
    }
    let obj = commonservices.fnCheckValidationOfObject(input);
    setInput({
      ...obj.obj,
    });
    if (obj.isValid) {
      setLoading(true);
      let body = {
        userid: param?.id,
        password: input.password.trim(),
        confirm_password: input.password.trim(),
      };

      //
      dispatch(ChangeLoginPassword(body)).then((res) => {
        if (res?.payload?.isValidate) {
          setLoading(false);
          navigate("/");
          // dispatch(userToken(response?.data?.data?.dataList1[0]?.accesstoken));
          // dispatch(userInfo(response?.data?.data?.dataList1[0]));
          // dispatch(userRoleRight(response?.data?.data?.dataList2));
          // 3-12 new changes by ak
        } else {
          setLoading(false);
        }
      });

      // ------------- Before redux

      // let resData = await apiCall(
      //   {
      //     method: "POST",
      //     url: API_URL.BASEURL + API_URL.CHANGE_PASSWORD,
      //     body: body,
      //   },
      //   true
      // );
      // let response = apiResponse(true, resData, setLoading);
      // if (response?.isValidate) {
      //   navigate("/");
      //   // dispatch(userToken(response?.data?.data?.dataList1[0]?.accesstoken));
      //   // dispatch(userInfo(response?.data?.data?.dataList1[0]));
      //   // dispatch(userRoleRight(response?.data?.data?.dataList2));
      //   // 3-12 new changes by ak
      // }
      // if (!response?.isValidate) {
      // }
    }
  };
  useEffect(() => {
    const cleanup = commonservices.setupKeyPressHandler(handleSubmit);
    return cleanup;
  }, [handleSubmit]);
  return (
    <div className="login-page-main-wrapper">
      {Loading && <MainpageLoader/>}
      <div className="w-100 text-start loginlogo-wrapper">
        <img src={logo} alt="logo" className="loginlogo" />
      </div>
      <div className="login-page-main">
        <div className="login-right ms-auto">
          <div className="loginleftnew">
            <div className="loginleftnew-svg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="110"
                height="110"
                viewBox="0 0 110 110"
                fill="none"
              >
                <path
                  className="rotate-clockwise"
                  d="M25.5282 89.5002C21.5581 87.2081 19.7936 80.9488 14.9413 80.9488C11.9417 81.3014 6.3836 83.0646 5.14846 78.9211C4.53089 75.3947 -2.0859 65.6972 2.76642 62.9643C4.97202 61.4656 9.47143 59.7024 9.11854 56.3524C8.32452 52.7378 10.9713 47.9772 7.70696 45.2443C5.41314 43.393 0.207916 40.7482 2.23707 36.9573C4.35444 34.0481 6.47183 22.4111 11.8535 23.9979C14.5002 24.3506 18.9114 26.2901 21.0288 23.7334C23.0579 20.6479 28.2631 19.1492 27.9102 14.9175C27.6456 12.0083 25.7929 6.36609 29.9394 5.13186C33.4684 4.60291 43.2612 -2.09721 45.9079 2.75155C47.496 4.95553 49.2604 9.45166 52.5247 9.09903C56.1419 8.39375 60.9942 10.9504 63.6409 7.77664C65.5819 5.4845 68.2286 0.194934 72.0222 2.31076L82.6091 7.15951C86.5792 8.74638 84.4618 14.0359 83.9325 17.0334C83.2267 21.1768 88.3437 23.1163 90.1081 26.2901C93.4606 30.698 101.577 23.8216 103.783 29.9928L107.841 40.8363C109.517 44.8035 104.312 47.0956 101.754 48.7707C98.4012 51.2391 100.607 56.176 99.6363 59.7906C98.9305 62.9643 103.43 65.1683 105.371 66.8433C110.047 69.8407 102.636 79.1856 101.842 82.5356C100.254 86.591 94.9605 84.387 91.9608 83.858C87.8143 83.2409 85.7852 88.266 82.6091 90.1173C79.8742 91.8805 81.5504 96.6411 81.7269 99.1977C82.8738 104.664 71.0518 105.986 68.0521 107.837C64.0821 109.512 61.8765 104.223 60.112 101.754C57.6417 98.3162 52.7894 100.52 49.1722 99.5504C45.9079 98.8451 43.7906 103.429 42.1143 105.369C39.0265 110.041 29.7629 102.636 26.3222 101.754C21.7346 99.9912 25.2635 92.6739 25.5282 89.5002Z"
                  fill="#FEFEFE"
                  stroke="#231F20"
                  stroke-width="2"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                />
                <path
                  className="rotate-counterclockwise"
                  d="M81.0219 44.1862C93.9909 79.2736 42.027 99.3739 27.9111 64.7274C14.9422 29.64 66.9061 9.53968 81.0219 44.1862Z"
                  stroke="#231F20"
                  stroke-width="2"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                />
              </svg>
            </div>
            <div className="dots-svg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="53"
                height="11"
                viewBox="0 0 53 11"
                fill="none"
              >
                <path
                  className="path path3"
                  d="M28.7472 10.2202C25.8359 10.132 19.572 11.3663 19.6602 6.60569C19.3955 3.96091 19.6602 -0.00627534 23.2773 0.0818839C26.1887 0.170043 32.4526 -1.06415 32.3644 3.69644C32.6291 6.34122 32.3644 10.3084 28.7472 10.2202Z"
                />
                <path
                  className="path path2"
                  d="M9.25049 10.2202C6.3391 10.132 -0.0129968 11.3663 0.0752272 6.60569C-0.189445 3.96091 0.0752058 -0.00627534 3.69239 0.0818839C6.692 0.170043 12.9559 -1.06415 12.8677 3.69644C13.1324 6.34122 12.8677 10.3084 9.25049 10.2202Z"
                />
                <path
                  className="path path1"
                  d="M48.3335 10.2202C45.3339 10.132 39.07 11.3663 39.1582 6.60569C38.8936 3.96091 39.1582 -0.00627534 42.7754 0.0818839C45.6868 0.170043 52.0389 -1.06415 51.9507 3.69644C52.2154 6.34122 51.9507 10.3084 48.3335 10.2202Z"
                />
              </svg>
            </div>
            <div className="dots-svg2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="53"
                height="11"
                viewBox="0 0 53 11"
                fill="none"
              >
                <path
                  className="path path3"
                  d="M28.7472 10.2202C25.8359 10.132 19.572 11.3663 19.6602 6.60569C19.3955 3.96091 19.6602 -0.00627534 23.2773 0.0818839C26.1887 0.170043 32.4526 -1.06415 32.3644 3.69644C32.6291 6.34122 32.3644 10.3084 28.7472 10.2202Z"
                />
                <path
                  className="path path2"
                  d="M9.25049 10.2202C6.3391 10.132 -0.0129968 11.3663 0.0752272 6.60569C-0.189445 3.96091 0.0752058 -0.00627534 3.69239 0.0818839C6.692 0.170043 12.9559 -1.06415 12.8677 3.69644C13.1324 6.34122 12.8677 10.3084 9.25049 10.2202Z"
                />
                <path
                  className="path path1"
                  d="M48.3335 10.2202C45.3339 10.132 39.07 11.3663 39.1582 6.60569C38.8936 3.96091 39.1582 -0.00627534 42.7754 0.0818839C45.6868 0.170043 52.0389 -1.06415 51.9507 3.69644C52.2154 6.34122 51.9507 10.3084 48.3335 10.2202Z"
                />
              </svg>
            </div>
            <div className="dots-svg3">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="53"
                height="11"
                viewBox="0 0 53 11"
                fill="none"
              >
                <path
                  className="path path3"
                  d="M28.7472 10.2202C25.8359 10.132 19.572 11.3663 19.6602 6.60569C19.3955 3.96091 19.6602 -0.00627534 23.2773 0.0818839C26.1887 0.170043 32.4526 -1.06415 32.3644 3.69644C32.6291 6.34122 32.3644 10.3084 28.7472 10.2202Z"
                />
                <path
                  className="path path2"
                  d="M9.25049 10.2202C6.3391 10.132 -0.0129968 11.3663 0.0752272 6.60569C-0.189445 3.96091 0.0752058 -0.00627534 3.69239 0.0818839C6.692 0.170043 12.9559 -1.06415 12.8677 3.69644C13.1324 6.34122 12.8677 10.3084 9.25049 10.2202Z"
                />
                <path
                  className="path path1"
                  d="M48.3335 10.2202C45.3339 10.132 39.07 11.3663 39.1582 6.60569C38.8936 3.96091 39.1582 -0.00627534 42.7754 0.0818839C45.6868 0.170043 52.0389 -1.06415 51.9507 3.69644C52.2154 6.34122 51.9507 10.3084 48.3335 10.2202Z"
                />
              </svg>
            </div>
            <img src={loginleft} alt="loginleft" />
          </div>
          <div className="main-login-form">
            <h3>Reset Password</h3>
            <p>
              Reset your password by entering a new password and confirming it
              below.
            </p>
            <div className="login-form-inner">
              <Form
                onSubmit={(e) => {
                  handleSubmit(e);
                }}
              >
                <Form.Group className="form-group">
                  <Form.Label className="login-label">
                    New Password<span className="ms-1 red-color-text">*</span>
                  </Form.Label>
                  <div className="input-type-pass">
                    <Form.Control
                      type={passwordVisible ? "text" : "password"}
                      placeholder="Enter your new password here"
                      className="login-input"
                      maxLength={67}
                      value={input.password}
                      onChange={(e) =>
                        fnInputChange(e.target.value, "password")
                      }
                      isInvalid={input?.errors?.password}
                    />
                    {input.errors.password && (
                      <Form.Control.Feedback type="invalid">
                        <span className="error-message-icon">
                          <img
                            src={infoIcon}
                            alt="infoIcon"
                            title={input.errors.password}
                          />
                        </span>
                      </Form.Control.Feedback>
                    )}
                    <img
                      src={passwordVisible ? openeye : closeeye}
                      alt="closeeye"
                      onClick={() => setPasswordVisible(!passwordVisible)}
                    />
                  </div>
                </Form.Group>
                <Form.Group className="form-group">
                  <Form.Label className="login-label">
                    Confirm Password
                    <span className="ms-1 red-color-text">*</span>
                  </Form.Label>
                  <div className="input-type-pass">
                    <Form.Control
                      type={C_passwordVisible ? "text" : "password"}
                      placeholder="Enter your confirm password here"
                      className="login-input"
                      maxLength={67}
                      value={input.confirm_password}
                      onChange={(e) =>
                        fnInputChange(e.target.value, "confirm_password")
                      }
                      isInvalid={input?.errors?.confirm_password}
                    />
                    {input.errors.confirm_password && (
                      <Form.Control.Feedback type="invalid">
                        <span className="error-message-icon">
                          <img
                            src={infoIcon}
                            alt="infoIcon"
                            title={input.errors.confirm_password}
                          />
                        </span>
                      </Form.Control.Feedback>
                    )}
                    {input.confirm_password !== "" &&
                    input.confirm_password === input.password ? (
                      // input.confirm_password === "" &&
                      //   input.confirm_password !== input.password &&
                      <>
                        {" "}
                        <img src={verifiedIcon} alt="verified" />
                      </>
                    ) : (
                      <img
                        src={C_passwordVisible ? openeye : closeeye}
                        alt="closeeye"
                        onClick={() => setC_PasswordVisible(!C_passwordVisible)}
                      />
                    )}
                    {/* {input.confirm_password !== "" &&
                      input.confirm_password === input.password && <>icon</>} */}
                  </div>
                </Form.Group>
                <button
                  disabled={Loading}
                  className="blue-sign-in-btn w-100"
                  type="submit"
                >
                  {Loading ? (
                    // <>
                    //   <span>Loading</span>{" "}
                    //   <Spinner
                    //     className="ms-1"
                    //     animation="border"
                    //     role="status"
                    //     size="sm"
                    //   >
                    //     <span className="visually-hidden">Loading...</span>
                    //   </Spinner>
                    // </>
                    <SubmitLoading />
                  ) : (
                    "Submit"
                  )}
                </button>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ChangePassword;
